import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const editProveedorFormSchema = z.object({
    numDocumento: z.string().nonempty("Este campo es requerido"),
    nombre: z.string().nonempty("Este campo es requerido"),
    email: z.email(),
    telefono: z.string(),
    direccion: z.string()
})

export default function EditProveedorForm({
    form,
    ...props
}: FormProps<z.infer<typeof editProveedorFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.TextField name="numDocumento" label="N° Documento" />
        <Form.TextField name="nombre" label="Nombre" />
        <Form.TextField name="email" label="Email" />
        <Form.TextField name="telefono" label="Telefono" />
        <Form.TextField name="direccion" label="Dirección" />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}